import { useState, useEffect } from "react";
import Table from "../Table/Table";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { Bounce, toast } from "react-toastify";
import PopUp from "../PopUp";

const TitoloStudio = () => {
  const [loading, setLoading] = useState(false);
  const [titoliStudi, setTitoliStudi] = useState([]);
  const navigate = useNavigate();
  const [perPage] = useState(20);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showPopUp, setShowPopUp] = useState(false);
  const [selectedTitoliId, setSelectedTitoliId] = useState(null);

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      alert("Accedi come amministratore per visualizzare i titoli di studio!");

      navigate("/login");
    } else {
      fetchTitoliStudi();
    }
  }, [navigate]);

  const fetchTitoliStudi = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/titoli-studio`);
      if (response.status === 200) {
        setTitoliStudi(response.data);
        setTotalRows(response.data.length);
      } else {
        toast.error("Qualcosa è andato storto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRowClick = (titoliStudi) => {
    navigate(`/titoli-studi/${titoliStudi.idTitoloTrainer}`, {
      state: { titoliStudi },
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedTitoliStudi = titoliStudi.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  const columns = [
    {
      header: "Tipo Titolo",
      accessorFn: (row) => row.tipologiaTitolo?.titoloTipologia ?? "",
      Cell: ({ row }) => row.original.tipologiaTitolo?.titoloTipologia || "—",
    },

    { field: "nomeTitolo", header: "Nome Titolo", accessorKey: "nomeTitolo" },

    {
      header: "Rilasciato",
      accessorKey: "rilasciatoIl",
      Cell: ({ row }) => {
        const ril = row.original.rilasciatoIl;
        if (!ril) return "—";
        const d = new Date(ril);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}.${month}.${year}`;
      },
    },

    { field: "da", header: "Da", accessorKey: "da" },

    {
      header: "Azioni",
      accessorKey: "azioni",
      Cell: ({ row }) => (
        <button
          className="outside-delete-btn"
          onClick={(e) => {
            e.stopPropagation();
            setSelectedTitoliId(row.original.idTitoloTrainer);
            setShowPopUp(true);
          }}
        >
          <i className="fa-solid fa-trash"></i> Elimina
        </button>
      ),
    },
  ];

  const handleDelete = async () => {
    if (!selectedTitoliId) {
      return;
    }
    try {
      setLoading(true);
      const response = await api.delete(`/titoli-studio/${selectedTitoliId}`);
      if (response.status === 204) {
        toast.success("Titoli di studi eliminata con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        fetchTitoliStudi();
      } else {
        toast.error("Qualcosa è andato storto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
      setSelectedTitoliId(null);
      setShowPopUp(false);
    }
  };

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <PopUp
        open={showPopUp}
        setOpen={setShowPopUp}
        header="Conferma Eliminazione"
        content="Sei sicuro di voler rimuovere questo titoli studio?"
        deleteFunction={handleDelete}
      />

      <div className="page-header">
        <div className="page-title">Titoli di studio</div>
        <div className="controls">
          <div className="add-btn">
            <button onClick={() => navigate("/aggiungi-titoli-studi")}>
              + Nuovo titolo
            </button>
          </div>
        </div>
      </div>

      <div className="page-content sedi">
        {titoliStudi.length > 0 && (
          <Table
            columns={columns}
            data={paginatedTitoliStudi}
            onRowClick={handleRowClick}
            onPageChange={handlePageChange}
            totalRows={totalRows}
            perPage={perPage}
            currentPage={currentPage}
          />
        )}
      </div>
    </div>
  );
};

export default TitoloStudio;
